/**
 * Page manager screen types
 * @module services/pm-screen/types
 */

/**
 * Page manager screen type for member home
 */
export const PM_SCREEN_TYPE_MEMBER_HOME = 'member-home'

/**
 * Page manager screen type for yoga
 */
export const PM_SCREEN_TYPE_YOGA_HOME = 'yoga-home'

/**
 * Page manager screen type for centers
 */
export const PM_SCREEN_TYPE_CENTERS = 'centers'
